<template>
  <div class="card"
       :style="{ backgroundColor: `${primaryColor}`}"
       :class="align">
    <router-link :to="{path:this.highlight.metadata.djschedule.metadata.event_link }"

                 class="card-animation-on-hover-no-bg">
      <ResponsiveImage align="text-center" :clamp="true"
                       hs="250" ws="350"
                       wl="500" hl="300"
                       :image="this.highlight.metadata.main_image.imgix_url"
                       >
      </ResponsiveImage>
      <br>
      <div class="artist-intro-card">


          <router-link :to="{path: this.highlight.metadata.djschedule.metadata.artist_link}">
            <h3 class="artist-name " > {{ this.highlight.metadata.djschedule.title.split('@')[0] }}</h3>
          </router-link>
        <hr>
        <EventVenue :title="this.highlight.metadata.djschedule.title" icon="true" class="a"></EventVenue>
        <p class="alt-font text-center ar" style="font-size: 1.1rem;padding: 10px"
           v-if="this.highlight.metadata.djschedule.metadata.date">
          {{
            attachPrettyDate(this.highlight.metadata.djschedule.metadata.date + 'T' + this.highlight.metadata.djschedule.metadata.start_time)
          }}
        </p>
      </div>
    </router-link>
  </div>
</template>
<script>
import ResponsiveImage from '@/components/HeadImage/ResponsiveImage';
import { COSMIC_BASE_URL } from '@/common/request';
import { eventDateMixin } from '@/common/eventDateMixin';
import EventVenue from '@/components/EventCard/EventVenue';

export default {
  name: 'HotThisWeek',
  mixins: [eventDateMixin],
  created: function() {
    fetch(encodeURI(`${COSMIC_BASE_URL}&props=title,slug,metadata.main_image,metadata.djschedule&query={"type":"artisthighlight","slug":"highlight" }`)).then((response) => {
      response.json().then((r) => {
        this.highlight = r.objects[0];
      });
    });
  },
  data: () => {
    return {
      fireImg: 'https://imgix.cosmicjs.com/15cd3df0-02af-11f0-9c94-c1d9b01cc071-e7b0917d2772c83bd52a9d011624c536.webp?q=&w=50&h=50&fit=clamp',
      highlight: { metadata: { main_image: {}, djschedule: { title: 'loading @ ...', metadata: { main_image: {} } } } }
    };
  },
  components: { EventVenue, ResponsiveImage },
  props: {
    primaryColor: {
      type: String,
      default: ''
    },
    secondaryColor: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'text-left'
    }
  }

};
</script>
